<div class="row container-form-list">
    <div class="col-12">
        <div class="card">
            <div class="card-header">
                <span class="info">Informe os usuários da expedição</span>
            </div>
            <div class="table-responsive">
                <table class="table table-striped table-hover table-bordered">
                    <thead>
                        <tr>
                            <th class="col-delete"></th>
                            <th class="col-nome">Nome</th>
                            <th class="col-situacao">Situação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let entity of entities; let i = index">
                            <td class="col-delete">
                                <a class="btn btn-link" (click)="delete(i)">
                                    <i class="far fa-trash-alt" aria-hidden="true"></i>
                                </a>
                            </td>                     
                            <td class="col-nome">
                                <input type="text" class="form-control" [(ngModel)]="entity.nome" name="usuarioExpedicaoNome_{{i}}" id="usuarioExpedicaoNome_{{i}}"
                                    #nome="ngModel" maxlength="255">
                                <sgt-form-control-error
                                    *ngIf="nome.errors && nome.errors.maxlength"
                                    msgError="O nome deve ter no máximo 255 caracteres">
                                </sgt-form-control-error>         
                            </td>
                            <td class="col-perc-participacao text-right">
                                <select class="form-control" name="usuarioExpedicaoSituacao_{{i}}" id="usuarioExpedicaoSituacao_{{i}}"
                                    [ngModel]="entity.situacao || ''" (ngModelChange)="entity.situacao = $event ? $event : null"
                                    #situacao="ngModel">
                                    <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                                </select>                                                                                
                            </td>                           
                        </tr>
                        <tr *ngIf="entities.length === 0" class="no-record">
                            <td class="text-center" colspan="5">
                                <i class='fas fa-info' aria-hidden='true'></i> Nenhum registro encontrado
                            </td>
                        </tr>
                    </tbody>                   
                </table>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-primary" (click)="insert()">
                    <i class="fas fa-plus" aria-hidden="true"></i>
                </button>
            </div>
        </div>        
    </div>
</div>
    